













import {Component, Prop, Vue} from "vue-property-decorator";
import {Element} from "../../../../api/models/Element";
import EventFooter from "../EventFooter.vue";
import PartnersList from "@share/common/partners-list/PartnersList.vue";
import { getImageUrl } from "@common/ImageUrlHelper";
import EventTitle from "./EventTitle.vue"

import { EventInfoData } from "../../types/EventInfoData"


@Component({
    name: 'EventInfo',
    components: { EventFooter, PartnersList, EventTitle }
})
export default class EventInfo extends Vue {
    /**
     * Data helper for data manipulation, comes from vuex store by date
     */
    @Prop({required: true}) eventInfoData: EventInfoData;
    @Prop({required: true}) eventId: string;

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get selectedEvent(): Element | undefined {
        return this.$store.getters['events/selectedEvent'];
    }

    get backgroundImageUrl(): string {
        const stageFileId = this.selectedEvent?.stageFileId;

        return getImageUrl(this.$route.params.backend, stageFileId, 1980);
    }

    get speakers() {
        return this.eventInfoData.speakers;
    }

    get partners() {
        return this.eventInfoData.partners;
    }

    get sessionPreviewId() {
        return this.eventInfoData.previewObject?.id || null
    }
}
